module.exports = __webpack_public_path__ + "static/media/Protocol-Formoplast-OSA-22.06.2018_NoData.4fce3f5d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Protocol-Formoplast-OSA-22.06.2018_NoData.pdf
// module id = 134
// module chunks = 0